import { Uchain } from "../redux/api/agent";
import { call, put, takeEvery } from 'redux-saga/effects';
import { sagaActions } from './sagaActions';
import { getExcelPoFileFailure, getExcelPoFileSuccess, resetExcelPoFileStatus, updateLastEvaluatedKey, updateLoading, updateSuccess, updateSuccessFailedData } from "../redux/reducers/reducerSlices/ExcelPoFileReducer";



function* getExcelPoFileListSaga(data) {
  try {
    if (data.payload.pageNo === 1) {
      yield put(resetExcelPoFileStatus());
    }
    yield put(updateLoading(true));
    const response = yield call(Uchain.getExcelPoFileList, data.payload);
    yield put(getExcelPoFileSuccess(response.Items));
    yield put(updateLastEvaluatedKey(response.lastEvaluatedKey || null));
  } catch (error) {
    yield put(getExcelPoFileFailure(error));
  }finally {
    yield put(updateLoading(false));
  } 
}

function* addExcelPoFileSaga(data) {
  try {
    yield put(updateLoading(true));

    const response = yield call(Uchain.addPoExcelFileLoads, data.payload);
    yield put(updateSuccess(response));
  } catch (error) {
    yield put(getExcelPoFileFailure(error));
  }finally {
    yield put(updateLoading(false));
  }
}

function* resetExcelPoFileSaga() {
  try {
    yield put(resetExcelPoFileStatus());
  } catch (error) {
   
  }
}

function* getSuccessFailedListSaga(data) {
  try {
    yield put(updateLoading(true));
    const response = yield call(Uchain.getSuccessFailedListBySessionId, data.payload);
    yield put(updateSuccessFailedData(response));
  } catch (error) {
    yield put(getExcelPoFileFailure(error));
  }finally {
    yield put(updateLoading(false));
  } 
}




export function* getExcelPoFileListWatcher() {
    yield takeEvery(sagaActions.GET_EXCEL_PO_FILE_LIST, getExcelPoFileListSaga)
}

export function* addExcelPoFileWatcher() {
  yield takeEvery(sagaActions.ADD_EXCEL_PO_FILE, addExcelPoFileSaga);
}

export function* resetExcelPoFileWatcher() {
  yield takeEvery(sagaActions.RESET_EXCEL_PO_FILE, resetExcelPoFileSaga);
}

export function* getSuccessFailedListWatcher() {
    yield takeEvery(sagaActions.SUCCESS_FAILED_DATA_BY_SESSIONID, getSuccessFailedListSaga)
}

